(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["headscripts"] = factory();
	else
		root["Site"] = root["Site"] || {}, root["Site"]["headscripts"] = factory();
})(self, () => {
return 